import React from 'react'
import {instance as elementTypeService} from '../../services/ElementTypeService'
import {CanvasEditorForElementsStep} from './CanvasEditorForElementsStep'

export function CanvasEditorOtherElements() {
  return (
    <CanvasEditorForElementsStep
      availableElementTypes={elementTypeService.getOtherElementTypes()}
    />
  )
}
